import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi, baseURL } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { act } from "react-dom/test-utils";
import config from "../config";

class GeofencesStore {
  geofencesReport = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      geofencesReport: observable,
      total: observable,
      loading: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, geofence,userId,isadmin }) {
    this.loading = true;

    var postData = {
      tokenId: "",
      companyId: companyId,
      geofence: geofence,
      limit: limit,
      offset: offset,
      userId:userId,
      isAdmin:isadmin
    };
    var response = await postApi
      .getClient()
      .get(config.NodeUrl + "/geofenceManagement/search", {
        params: postData,
      });
    this.geofencesReport = response?.data?.data?.geofencelist;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;
  }

  async exportExcel(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/geofenceManagement/exportExcel", getData, {
          responseType: "blob",
        });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Geofence list Report.xlsx";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportpdf(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/geofenceManagement/exportPdf", getData, {
          responseType: "blob",
        });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Geofence list Report.pdf";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }

  async exportcsv(getData) {
    try {
      var response = await postApi
        .getClient("")
        .post(config.NodeUrl + "/geofenceManagement/exportCsv", getData, {
          responseType: "blob",
        });
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Geofence list Report.csv";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading the file", error);
    }
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=vehicle&a=exportgeofencelistxml&cid=" +
      getData.companyId +
      // "&vid=" +
      // getData.vehicleId +
      // "&int="+
      // getData.interval+
      // "&fD=" +
      // getData.fromDate +
      // "&tD=" +
      // getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}

export default GeofencesStore;
